var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"10","lg":"10","xl":"10"}},[_c('v-sheet',{staticClass:"pa-12",attrs:{"min-height":"70vh","rounded":"lg"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }